<template>
    <v-dialog v-model="load" max-width="60%" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="'Foto De Inspección'"></span>
                <v-spacer></v-spacer>
                <v-btn color="primary" rounded outlined @click="close">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container fluid grid-list-sm>
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-text-field label="Asegurado" color="textbox" v-model="obModal.asegurado" outlined dense
                                readonly />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="4" class="mb-1 text-center" v-for="(v,k) in listFotos" :key="k">
                            <v-btn color="white" width="270" height="160" dark text>
                                <div class="box text-center">
                                    <img :src="v.base64" />                                    
                                </div>
                            </v-btn>
                            <div class="text-center">
                                <span v-html="v.fechaFoto"></span>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalFotoInspeccionComponent',
        inject: ['close'],
        props: {
            listFotos: {
                type: Array,
                default: () => []
            },
            load: {
                type: Boolean,
                default: false
            },
            obModal:{
                type: Object,
                default:{}
            }
        }

    }
</script>

<style type="text/css">
    .box {
        height: 120px;
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .box>img {
        max-width: 100%;
        max-height: 130%;
    }
</style>